import { render, staticRenderFns } from "./MenuNavigator.vue?vue&type=template&id=de8aec68&scoped=true"
import script from "./MenuNavigator.vue?vue&type=script&lang=js"
export * from "./MenuNavigator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de8aec68",
  null
  
)

export default component.exports